export type RecentlyViewedItem = {
  id?: number;
  slug?: string;
  title: string;
  chapterTitle?: string;
  author: string;
  cover?: string | null;
  position?: number;
  duration?: number;
  updatedAt: string;
};

const STORAGE_KEY = 'ebookapp.recentlyViewed';

function getStorage() {
  return typeof globalThis !== 'undefined' && 'localStorage' in globalThis
    ? globalThis.localStorage
    : undefined;
}

export function saveRecentlyViewed(item: Omit<RecentlyViewedItem, 'updatedAt'>) {
  const storage = getStorage();
  if (!storage) return;

  storage.setItem(STORAGE_KEY, JSON.stringify({
    ...item,
    updatedAt: new Date().toISOString(),
  }));
}

export function getRecentlyViewed(): RecentlyViewedItem | null {
  const storage = getStorage();
  if (!storage) return null;

  const raw = storage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as RecentlyViewedItem;
  } catch {
    storage.removeItem(STORAGE_KEY);
    return null;
  }
}
